import {ReactNode} from 'react';
import {RowItem, Icon, Text} from './styled';

interface VerificationStepItemProps {
  icon: ReactNode;
  text?: string;
  isFixed?: boolean;
  className?: string;
}

const VerificationStepItem = ({icon, text, className}: VerificationStepItemProps) => {
  return (
    <RowItem className={className}>
      <Icon>{icon}</Icon>
      <Text>{text || ' '}</Text>
    </RowItem>
  );
};

export {VerificationStepItem};
